import {Email, matchEmail, ValidEmail} from 'Core/models/Email';
import React, {useState} from 'react';
import {Errors} from 'Shared/components/ErrorPopover';
import ValidatableTextField from 'Shared/components/ValidatableTextField';
import './EmailInput.sass';

type EmailProps = {
  className?: string;
  email: Email;
  disabled?: boolean;
  variant?: any;
  label?: string;
  onChange: (emailAddress: Email) => any;
};

const EmailInput = (props: EmailProps) => {
  const [hasBlurredEmail, setHasBlurredEmail] = useState(false);

  return (
    <ValidatableTextField
      label={props.label || 'Email'}
      disabled={props.disabled}
      className={props.className}
      errors={Errors.standardErrors({
        value: matchEmail(props.email, {
          InvalidEmail: invalid => [invalid.validationError],
          UnvalidatedEmail: () => [],
          ValidEmail: () => [],
        }),
      })}
      showErrors={errors => hasBlurredEmail && errors.value.length > 0}
      value={props.email.address}
      onChange={address => props.onChange(ValidEmail.create(address))}
      onBlur={() => setHasBlurredEmail(true)}
    />
  );
};

export default EmailInput;
